import React, { useEffect, useState } from "react";
import { FaInstagram, FaTiktok, FaGlobe } from "react-icons/fa";
import { getAllboothsList, getCities, groupByCity } from "../../services/Booths";
import { useNavigate } from "react-router-dom";
import ls from "local-storage";
import { event } from "../../utils/gtag";
import { useLocation } from "react-router-dom";

const socials = [
  {
    icon: <FaInstagram />,
    url: "https://instagram.com/sukhakala.id",
  },
  {
    icon: <FaTiktok />,
    url: "https://tiktok.com/@sukhakala.id",
  },
  {
    icon: <FaGlobe />,
    url: "https://sukhakala.id",
  },
];

export default function LocationsList() {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const utmSource = params.get("utm_source");

  useEffect(() => {
    if (utmSource && window.gtag) {
      window.gtag("set", "user_properties", {
        utm_source: utmSource,
      });
    }
  }, [utmSource]);
  const [cityList, setCityList] = useState([]);
  function fetchboothsList() {
    getCities().then((response) => {
      setCityList(response.data);
    });
  }
  function fetchLS() {
    if (ls.get("userDetail")) {
      const userDetail = ls.get("userDetail");
    }
  }
  useEffect(() => {
    fetchboothsList();
    fetchLS();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-yellow-50 to-pink-50 flex flex-col items-center px-4 py-8">
      <img src="/latest-logo.jpg" alt="Sukhakala Logo" className="w-24 h-24 mb-4 rounded-full object-cover" />
      <h1 className="text-3xl font-bold text-center mb-2">Sukhakala Photobooth</h1>
      Keeping memories alive with the new ✨love language✨
      <br />
      <br />
      {/* Social Icons */}
      <div className="flex space-x-4 mb-8">
        {socials.map((social, idx) => (
          <a
            key={idx}
            href={social.url}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() =>
              event({
                action: "click_link",
                category: "LocationsList",
                label: social.url,
              })
            }
            className="text-2xl text-pink-600 hover:text-pink-800 transition"
          >
            {social.icon}
          </a>
        ))}
      </div>
      {/* Branch List */}
      <h2 className="text-xl font-semibold mt-2 mb-4">📍 Our Branches</h2>
      <div className="flex flex-col gap-4 w-full max-w-md">
        {cityList.length === 0 ? (
          <div className="text-gray-500">Loading branches...</div>
        ) : (
          cityList.map((city, cityIdx) => (
            <div className="flex flex-col gap-4">
              <a
                key={cityIdx}
                href={"cities/" + city.id}
                target="_blank"
                rel="noopener noreferrer"
                className="bg-[#2b478e] text-white text-center py-3 px-6 rounded-xl shadow hover:bg-[#e7ac46] transition"
                onClick={() =>
                  event({
                    action: "click_link",
                    category: "CitiesPage",
                    label: city.name,
                  })
                }
              >
                <span>📍 {city.name}</span>
              </a>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
